/**
 * @fileoverview > handler for the "/apps/:app_group_id/email_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdEmailSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdEmailSettingsProps, PostEmailSettingsApiEndpointResponse } from "./types";

export const postEmailSettingsApiEndpoint = reactQueryMutationAdapter(
  appsAppGroupIdEmailSettingsCacheKeys,
  ({
    appGroupId,
    emailSettingsPayload,
  }: PostAppsAppGroupIdEmailSettingsProps): Promise<PostEmailSettingsApiEndpointResponse> => {
    return fetch(`/apps/${appGroupId}/email_settings`, "POST", emailSettingsPayload);
  }
);
